import { inject, Injectable } from '@angular/core';
import { InfoApiService } from './api/info-api.service';
import { Observable, shareReplay } from 'rxjs';
import { IEntityLimitations } from '../../shared/models/info/entity-limitations';

@Injectable({
  providedIn: 'root',
})
export class EntityLimitationsService {
  private infoApiService = inject(InfoApiService);
  private entityLimitations$: Observable<IEntityLimitations[]> | undefined;

  public getEntityLimitations$(): Observable<IEntityLimitations[]> {
    if (!this.entityLimitations$) {
      this.entityLimitations$ = this.infoApiService.getEntityFieldLimitations().pipe(shareReplay(1));
    }
    return this.entityLimitations$;
  }
}
